import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { LineChart } from '@/modules/common/components/charts/v2';
import { PerformanceChart } from '@/modules/investments/types/Performance';
import { BaseText } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  chart: PerformanceChart;
  isLoading: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PerformanceChart',
  props: {
    chart: null,
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  chart: PerformanceChart;
  isLoading: boolean;
};



const computedLeftText = computed(
  () =>
    props.chart.axisX?.[0].range.start.formatted +
    ' a ' +
    props.chart.axisX?.[0].range.end.formatted
);

const computedRightText = computed(
  () => 'Atualizado ' + props.chart?.axisX?.[0].range.end.formatted
);

const portfolioData = computed(() => {
  const portfolio = props.chart?.axisY?.find(axis => axis.type === 'Portfolio');
  const profit = props.chart?.axisY?.find(axis => axis.type === 'Profit');

  return {
    name: portfolio?.name || '-',
    data: portfolio?.values.map(value => value.value) || [],
    comparator:
      profit?.values.map(value => (value ? value.formatted : null)) || [],
    benchmarkComparison:
      portfolio?.values.map(value =>
        value ? value.benchmarkComparison : null
      ) || []
  };
});

const benchmarkData = computed(() => {
  const benchmark = props.chart?.axisY?.find(axis => axis.type === 'Index');

  return {
    name: benchmark?.name || '-',
    data: benchmark?.values.map(value => value.value) || []
  };
});

const labels = computed(() => {
  return props.chart?.axisX?.[0]?.values?.map(value => value.value) || [];
});

return { __sfc: true,props, computedLeftText, computedRightText, portfolioData, benchmarkData, labels, LineChart, BaseText, NebraskaColors }
}

})